import headerTecnoLogo from "../../resources/images/header_tecno_logo.png";

import { Box, Grid, Link, SxProps, Theme } from "@mui/material";

export const SiteHeader = () => {
  return (
    <Grid container sx={containerSx}>
      <Link href="/">
        <Box sx={logoSx} component="img" alt="テクノスタンダード" src={headerTecnoLogo} />
      </Link>
    </Grid>
  );
};

const containerSx: SxProps<Theme> = (theme) => ({
  height: "64px",
  backgroundColor: "#373636",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  flexWrap: "nowrap",
});

const logoSx: SxProps<Theme> = (theme) => ({
  marginLeft: {
    md: "60px",
    xs: "16px",
  },
  height: {
    md: "auto",
    xs: "28px",
  },
  maxWidth: {
    md: "auto",
    xs: "180px",
  },
});
